/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from "react";
import { SvgIcon } from "@material-ui/core";

export const BurgerMenuIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M22.2 12.355h-20.4c-0.265 0-0.48-0.215-0.48-0.48s0.215-0.48 0.48-0.48v0h20.4c0.265 0 0.48 0.215 0.48 0.48s-0.215 0.48-0.48 0.48v0z" />
    <path d="M22.061 7.003h-20.261c-0.265 0-0.48-0.215-0.48-0.48s0.215-0.48 0.48-0.48v0h20.261c0.265 0 0.48 0.215 0.48 0.48s-0.215 0.48-0.48 0.48v0z" />
    <path d="M22.061 17.957h-20.261c-0.265 0-0.48-0.215-0.48-0.48s0.215-0.48 0.48-0.48v0h20.261c0.265 0 0.48 0.215 0.48 0.48s-0.215 0.48-0.48 0.48v0z" />
  </SvgIcon>
);

export const CloseMenuIcon = (props) => (
  <SvgIcon
    viewBox="0 0 63.408 63.408"
    style={{ enableBackground: "new 0 0 63.408 63.408" }}
    {...props}
  >
    <path
      d="M47.974,45.949L33.611,31.587l14.352-14.351c0.586-0.585,0.586-1.536,0-2.121c-0.586-0.586-1.535-0.586-2.121,0
	L31.49,29.466l-14.3-14.3c-0.586-0.586-1.535-0.586-2.121,0c-0.586,0.585-0.586,1.536,0,2.121l14.3,14.3l-14.311,14.31
	c-0.586,0.585-0.586,1.536,0,2.121c0.293,0.293,0.677,0.439,1.061,0.439s0.768-0.146,1.061-0.439l14.311-14.31L45.853,48.07
	c0.293,0.293,0.677,0.439,1.061,0.439s0.768-0.146,1.061-0.439C48.56,47.485,48.56,46.535,47.974,45.949z"
    />
  </SvgIcon>
);

export const ArrowRightIcon = (props) => {
  const { onHover, onPressed, onTouchStart, onTouchLeave, ...rest } = props;

  if (onPressed) {
    return (
      <SvgIcon viewBox="0 0 63.408 63.408" {...rest}>
        <g>
          <circle
            style={{ fill: "#C9C9C9" }}
            cx="31.14"
            cy="31.944"
            r="27.676"
          />
        </g>
        <g id="Gruppe_623_10_" transform="translate(21.603 21.603) rotate(180)">
          <g id="Ellipse_1_9_">
            <path
              style={{ fill: "#000001" }}
              d="M-9.537-28.795c10.176,0,18.455,8.279,18.455,18.455S0.639,8.114-9.537,8.114
			s-18.454-8.278-18.454-18.454S-19.713-28.795-9.537-28.795z M-9.537,6.114c9.073,0,16.455-7.381,16.455-16.454
			c0-9.073-7.382-16.455-16.455-16.455s-16.454,7.381-16.454,16.455C-25.991-1.268-18.61,6.114-9.537,6.114z"
            />
          </g>
          <path
            style={{ fill: "#000001" }}
            d="M-20.846-10.204C-20.846-10.203-20.847-10.203-20.846-10.204c0,0.017,0.008,0.03,0.009,0.046
		c0.005,0.114,0.023,0.227,0.067,0.334c0.052,0.125,0.127,0.237,0.221,0.331l8.411,8.413c0.391,0.391,1.023,0.391,1.414,0
		c0.391-0.39,0.391-1.023,0-1.414l-6.708-6.709H0.045c0.553,0,1-0.448,1-1s-0.447-1-1-1h-17.479l6.71-6.709
		c0.391-0.39,0.391-1.023,0-1.414c-0.195-0.195-0.451-0.293-0.707-0.293s-0.512,0.098-0.707,0.293l-8.416,8.415
		c-0.022,0.022-0.03,0.051-0.05,0.075c-0.064,0.077-0.126,0.156-0.166,0.249C-20.82-10.465-20.847-10.334-20.846-10.204z"
          />
        </g>
      </SvgIcon>
    );
  }
  if (onHover) {
    return (
      <SvgIcon viewBox="0 0 63.408 63.408" {...rest}>
        <g>
          <circle
            style={{ fill: "#F2F2F2" }}
            cx="31.14"
            cy="31.944"
            r="27.676"
          />
        </g>
        <g id="Gruppe_623_9_" transform="translate(21.603 21.603) rotate(180)">
          <g id="Ellipse_1_8_">
            <path
              style={{ fill: "#000001" }}
              d="M-9.537-28.795c10.176,0,18.455,8.279,18.455,18.455S0.639,8.114-9.537,8.114
			s-18.454-8.278-18.454-18.454S-19.713-28.795-9.537-28.795z M-9.537,6.114c9.073,0,16.455-7.381,16.455-16.454
			c0-9.073-7.382-16.455-16.455-16.455s-16.454,7.381-16.454,16.455C-25.991-1.268-18.61,6.114-9.537,6.114z"
            />
          </g>
          <path
            style={{ fill: "#000001" }}
            d="M-20.846-10.204C-20.846-10.203-20.847-10.203-20.846-10.204c0,0.017,0.008,0.03,0.009,0.046
		c0.005,0.114,0.023,0.227,0.067,0.334c0.052,0.125,0.127,0.237,0.221,0.331l8.411,8.413c0.391,0.391,1.023,0.391,1.414,0
		c0.391-0.39,0.391-1.023,0-1.414l-6.708-6.709H0.045c0.553,0,1-0.448,1-1s-0.447-1-1-1h-17.479l6.71-6.709
		c0.391-0.39,0.391-1.023,0-1.414c-0.195-0.195-0.451-0.293-0.707-0.293s-0.512,0.098-0.707,0.293l-8.416,8.415
		c-0.022,0.022-0.03,0.051-0.05,0.075c-0.064,0.077-0.126,0.156-0.166,0.249C-20.82-10.465-20.847-10.334-20.846-10.204z"
          />
        </g>
      </SvgIcon>
    );
  }
  return (
    <SvgIcon viewBox="0 0 63.408 63.408" {...rest}>
      <g>
        <circle
          style={{ fill: "transparent" }}
          cx="31.14"
          cy="31.944"
          r="27.676"
        />
      </g>
      <g id="Gruppe_623_9_" transform="translate(21.603 21.603) rotate(180)">
        <g id="Ellipse_1_8_">
          <path
            style={{ fill: "#000001" }}
            d="M-9.537-28.795c10.176,0,18.455,8.279,18.455,18.455S0.639,8.114-9.537,8.114
			s-18.454-8.278-18.454-18.454S-19.713-28.795-9.537-28.795z M-9.537,6.114c9.073,0,16.455-7.381,16.455-16.454
			c0-9.073-7.382-16.455-16.455-16.455s-16.454,7.381-16.454,16.455C-25.991-1.268-18.61,6.114-9.537,6.114z"
          />
        </g>
        <path
          style={{ fill: "#000001" }}
          d="M-20.846-10.204C-20.846-10.203-20.847-10.203-20.846-10.204c0,0.017,0.008,0.03,0.009,0.046
		c0.005,0.114,0.023,0.227,0.067,0.334c0.052,0.125,0.127,0.237,0.221,0.331l8.411,8.413c0.391,0.391,1.023,0.391,1.414,0
		c0.391-0.39,0.391-1.023,0-1.414l-6.708-6.709H0.045c0.553,0,1-0.448,1-1s-0.447-1-1-1h-17.479l6.71-6.709
		c0.391-0.39,0.391-1.023,0-1.414c-0.195-0.195-0.451-0.293-0.707-0.293s-0.512,0.098-0.707,0.293l-8.416,8.415
		c-0.022,0.022-0.03,0.051-0.05,0.075c-0.064,0.077-0.126,0.156-0.166,0.249C-20.82-10.465-20.847-10.334-20.846-10.204z"
        />
      </g>
    </SvgIcon>
  );
};
export const ArrowLeftIcon = (props) => {
  const { onHover, onPressed, onTouchStart, onTouchLeave, ...rest } = props;
  if (onPressed) {
    return (
      <SvgIcon viewBox="0 0 63.408 63.408" {...rest}>
        <g>
          <circle
            style={{ fill: "#C9C9C9" }}
            cx="31.14"
            cy="31.944"
            r="27.676"
          />
        </g>
        <g id="Gruppe_623_4_" transform="translate(21.603 21.603) rotate(180)">
          <g id="Ellipse_1_3_">
            <path
              style={{ fill: "#000001" }}
              d="M-9.536,8.114c-10.176,0-18.455-8.279-18.455-18.455s8.279-18.454,18.455-18.454
			S8.918-20.517,8.918-10.341S0.64,8.114-9.536,8.114z M-9.536-26.795c-9.073,0-16.455,7.381-16.455,16.454
			c0,9.073,7.382,16.455,16.455,16.455S6.918-1.268,6.918-10.341C6.918-19.414-0.463-26.795-9.536-26.795z"
            />
          </g>
          <path
            style={{ fill: "#000001" }}
            d="M1.773-10.478C1.773-10.478,1.774-10.478,1.773-10.478c0-0.017-0.008-0.03-0.009-0.046
		c-0.005-0.114-0.023-0.227-0.067-0.334c-0.052-0.125-0.127-0.237-0.221-0.331l-8.411-8.413c-0.391-0.391-1.023-0.391-1.414,0
		c-0.391,0.39-0.391,1.023,0,1.414l6.708,6.709h-17.476c-0.553,0-1,0.448-1,1s0.447,1,1,1h17.479L-8.35-2.77
		c-0.391,0.39-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293L1.481-9.77
		c0.022-0.022,0.03-0.051,0.05-0.075c0.064-0.077,0.126-0.156,0.166-0.249C1.747-10.217,1.774-10.347,1.773-10.478z"
          />
        </g>
      </SvgIcon>
    );
  }
  if (onHover) {
    return (
      <SvgIcon viewBox="0 0 63.408 63.408" {...rest}>
        <g>
          <circle
            style={{ fill: "#F2F2F2" }}
            cx="31.14"
            cy="31.944"
            r="27.676"
          />
        </g>
        <g id="Gruppe_623_7_" transform="translate(21.603 21.603) rotate(180)">
          <g id="Ellipse_1_6_">
            <path
              style={{ fill: "#000001" }}
              d="M-9.536,8.114c-10.176,0-18.455-8.279-18.455-18.455s8.279-18.454,18.455-18.454
			S8.918-20.517,8.918-10.341S0.64,8.114-9.536,8.114z M-9.536-26.795c-9.073,0-16.455,7.381-16.455,16.454
			c0,9.073,7.382,16.455,16.455,16.455S6.918-1.268,6.918-10.341C6.918-19.414-0.463-26.795-9.536-26.795z"
            />
          </g>
          <path
            style={{ fill: "#000001" }}
            d="M1.773-10.478C1.773-10.478,1.774-10.478,1.773-10.478c0-0.017-0.008-0.03-0.009-0.046
		c-0.005-0.114-0.023-0.227-0.067-0.334c-0.052-0.125-0.127-0.237-0.221-0.331l-8.411-8.413c-0.391-0.391-1.023-0.391-1.414,0
		c-0.391,0.39-0.391,1.023,0,1.414l6.708,6.709h-17.476c-0.553,0-1,0.448-1,1s0.447,1,1,1h17.479L-8.35-2.77
		c-0.391,0.39-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293L1.481-9.77
		c0.022-0.022,0.03-0.051,0.05-0.075c0.064-0.077,0.126-0.156,0.166-0.249C1.747-10.217,1.774-10.347,1.773-10.478z"
          />
        </g>
      </SvgIcon>
    );
  }
  return (
    <SvgIcon viewBox="0 0 63.408 63.408" {...rest}>
      <g>
        <circle
          style={{ fill: "transparent" }}
          cx="31.14"
          cy="31.944"
          r="27.676"
        />
      </g>
      <g id="Gruppe_623_7_" transform="translate(21.603 21.603) rotate(180)">
        <g id="Ellipse_1_6_">
          <path
            style={{ fill: "#000001" }}
            d="M-9.536,8.114c-10.176,0-18.455-8.279-18.455-18.455s8.279-18.454,18.455-18.454
			S8.918-20.517,8.918-10.341S0.64,8.114-9.536,8.114z M-9.536-26.795c-9.073,0-16.455,7.381-16.455,16.454
			c0,9.073,7.382,16.455,16.455,16.455S6.918-1.268,6.918-10.341C6.918-19.414-0.463-26.795-9.536-26.795z"
          />
        </g>
        <path
          style={{ fill: "#000001" }}
          d="M1.773-10.478C1.773-10.478,1.774-10.478,1.773-10.478c0-0.017-0.008-0.03-0.009-0.046
		c-0.005-0.114-0.023-0.227-0.067-0.334c-0.052-0.125-0.127-0.237-0.221-0.331l-8.411-8.413c-0.391-0.391-1.023-0.391-1.414,0
		c-0.391,0.39-0.391,1.023,0,1.414l6.708,6.709h-17.476c-0.553,0-1,0.448-1,1s0.447,1,1,1h17.479L-8.35-2.77
		c-0.391,0.39-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293L1.481-9.77
		c0.022-0.022,0.03-0.051,0.05-0.075c0.064-0.077,0.126-0.156,0.166-0.249C1.747-10.217,1.774-10.347,1.773-10.478z"
        />
      </g>
    </SvgIcon>
  );
};
export const ArrowTopIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M15.911 10.431l-3.754-3.754c-0.044-0.044-0.105-0.072-0.173-0.072h-0c-0.066 0.002-0.125 0.029-0.168 0.072v0l-3.754 3.754c-0.044 0.044-0.071 0.104-0.071 0.17 0 0.133 0.108 0.241 0.241 0.241 0.067 0 0.127-0.027 0.17-0.071v0l3.36-3.36v9.744c0 0.133 0.107 0.24 0.24 0.24v0c0.133 0 0.24-0.107 0.24-0.24v0-9.73l3.36 3.36c0.044 0.044 0.105 0.072 0.173 0.072h0c0.066-0.001 0.125-0.028 0.168-0.072l0-0c0.039-0.043 0.063-0.1 0.063-0.162 0-0.079-0.038-0.149-0.096-0.192l-0.001-0z" />
  </SvgIcon>
);
export const CloseIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M14.91 14.558l-2.558-2.558 2.558-2.558c0.044-0.043 0.071-0.104 0.071-0.17s-0.027-0.127-0.071-0.17l-0-0c-0.043-0.042-0.103-0.069-0.168-0.069s-0.125 0.026-0.168 0.069l-2.563 2.563-2.578-2.563c-0.043-0.044-0.104-0.071-0.17-0.071s-0.127 0.027-0.17 0.071l-0 0c-0.045 0.042-0.073 0.102-0.073 0.168s0.028 0.126 0.073 0.168l0 0 2.558 2.563-2.558 2.558c-0.044 0.043-0.071 0.104-0.071 0.17s0.027 0.127 0.071 0.17l0 0c0.043 0.044 0.102 0.072 0.168 0.072h0c0.068-0 0.129-0.028 0.173-0.072v0l2.578-2.578 2.563 2.563c0.042 0.045 0.102 0.073 0.168 0.073s0.126-0.028 0.168-0.073l0-0c0.040-0.043 0.064-0.1 0.064-0.163s-0.024-0.121-0.064-0.163l0 0z" />
  </SvgIcon>
);
export const ConfigurateIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M11.998 14.044c-0.001 0-0.003 0-0.005 0-1.129 0-2.045-0.915-2.045-2.045s0.915-2.045 2.045-2.045c1.129 0 2.045 0.915 2.045 2.045v0c0 0 0 0 0 0 0 1.128-0.913 2.042-2.040 2.045h-0zM11.998 10.44c-0.001 0-0.003 0-0.005 0-0.864 0-1.565 0.701-1.565 1.565s0.701 1.565 1.565 1.565c0.864 0 1.565-0.701 1.565-1.565 0-0.002 0-0.003 0-0.005v0c-0.003-0.86-0.7-1.557-1.56-1.56h-0z" />
    <path d="M13.154 16.704h-2.232c-0.133 0-0.24-0.107-0.24-0.24v0-0.835c-0.428-0.151-0.796-0.369-1.113-0.647l0.004 0.003-0.768 0.422c-0.034 0.021-0.075 0.033-0.119 0.033-0.087 0-0.162-0.048-0.202-0.119l-0.001-0.001-1.118-1.92c-0.021-0.035-0.034-0.076-0.034-0.121 0-0.088 0.048-0.164 0.119-0.204l0.001-0.001 0.73-0.422c-0.035-0.191-0.055-0.411-0.055-0.636s0.020-0.445 0.059-0.658l-0.003 0.022-0.73-0.422c-0.054-0.034-0.093-0.086-0.11-0.147l-0-0.002c-0.006-0.019-0.009-0.041-0.009-0.064 0-0.044 0.012-0.084 0.034-0.119l-0.001 0.001 1.118-1.92c0.044-0.073 0.123-0.121 0.214-0.121 0.043 0 0.084 0.011 0.119 0.030l-0.001-0.001 0.739 0.422c0.318-0.271 0.691-0.488 1.099-0.631l0.024-0.007v-0.864c0-0.133 0.107-0.24 0.24-0.24v0h2.237c0.133 0 0.24 0.107 0.24 0.24v0 0.84c0.417 0.152 0.776 0.369 1.083 0.641l-0.003-0.003 0.71-0.418c0.036-0.022 0.079-0.036 0.126-0.036 0.020 0 0.040 0.002 0.058 0.007l-0.002-0c0.063 0.017 0.114 0.059 0.143 0.114l0.001 0.001 1.118 1.92c0.020 0.034 0.032 0.076 0.032 0.12 0 0.088-0.047 0.164-0.117 0.206l-0.001 0.001-0.73 0.437c0.034 0.183 0.053 0.394 0.053 0.609 0 0.009-0 0.018-0 0.026v-0.001c0 0.008 0 0.018 0 0.028 0 0.216-0.019 0.427-0.056 0.632l0.003-0.022 0.734 0.422c0.072 0.041 0.12 0.117 0.12 0.205 0 0.045-0.013 0.087-0.034 0.122l0.001-0.001-1.109 1.92c-0.034 0.054-0.086 0.093-0.147 0.11l-0.002 0c-0.027 0.012-0.058 0.020-0.091 0.020s-0.064-0.007-0.093-0.020l0.001 0.001-0.715-0.418c-0.301 0.264-0.655 0.477-1.042 0.621l-0.023 0.008v0.835c0 0 0 0 0 0.001 0 0.133-0.107 0.24-0.24 0.24-0.007 0-0.013-0-0.020-0.001l0.001 0zM11.162 16.224h1.771v-0.773c0-0.109 0.072-0.2 0.171-0.23l0.002-0c0.467-0.14 0.867-0.382 1.191-0.701l-0 0c0.042-0.043 0.1-0.069 0.165-0.069 0.046 0 0.088 0.013 0.124 0.036l-0.001-0.001 0.662 0.384 0.874-1.517-0.672-0.384c-0.073-0.042-0.121-0.12-0.121-0.208 0-0.018 0.002-0.036 0.006-0.053l-0 0.002c0.046-0.213 0.072-0.458 0.072-0.71 0-0 0-0.001 0-0.001v0c0-0 0-0.001 0-0.001 0-0.249-0.026-0.493-0.076-0.728l0.004 0.023c-0.003-0.015-0.005-0.033-0.005-0.051 0-0.089 0.048-0.166 0.12-0.208l0.001-0.001 0.667-0.389-0.874-1.512-0.653 0.384c-0.035 0.020-0.076 0.032-0.121 0.032-0.067 0-0.128-0.027-0.172-0.070l0 0c-0.324-0.318-0.724-0.56-1.17-0.696l-0.020-0.005c-0.098-0.030-0.168-0.119-0.168-0.225 0-0.002 0-0.003 0-0.005v0-0.773h-1.776v0.773c0 0.109-0.072 0.2-0.171 0.23l-0.002 0c-0.482 0.141-0.896 0.385-1.235 0.707l0.001-0.001c-0.043 0.040-0.101 0.065-0.164 0.065-0.044 0-0.085-0.012-0.12-0.032l0.001 0.001-0.686-0.389-0.878 1.517 0.667 0.389c0.070 0.043 0.116 0.119 0.116 0.206 0 0.019-0.002 0.037-0.006 0.055l0-0.002c-0.043 0.211-0.069 0.454-0.072 0.704l-0 0.002c0.002 0.253 0.030 0.498 0.081 0.734l-0.004-0.023c0.003 0.015 0.005 0.033 0.005 0.051 0 0.089-0.048 0.166-0.12 0.208l-0.001 0.001-0.667 0.384 0.874 1.522 0.696-0.394c0.034-0.019 0.075-0.030 0.118-0.030 0.064 0 0.122 0.024 0.165 0.064l-0-0c0.342 0.325 0.763 0.569 1.232 0.701l0.021 0.005c0.101 0.030 0.173 0.122 0.173 0.23v0z" />
  </SvgIcon>
);
export const InfoIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M12.852 8.851c0 0.001 0 0.003 0 0.004 0 0.115-0.027 0.224-0.074 0.322l0.002-0.004c-0.044 0.103-0.106 0.191-0.182 0.264l-0 0c-0.076 0.076-0.167 0.138-0.268 0.18l-0.005 0.002c-0.099 0.042-0.215 0.067-0.336 0.067v0c-0 0-0 0-0 0-0.118 0-0.23-0.025-0.332-0.069l0.005 0.002c-0.202-0.087-0.359-0.245-0.444-0.441l-0.002-0.005c-0.043-0.090-0.067-0.195-0.067-0.306 0-0.005 0-0.011 0-0.016l-0 0.001c-0-0.005-0-0.011-0-0.016 0-0.116 0.025-0.226 0.069-0.325l-0.002 0.005c0.044-0.104 0.104-0.193 0.178-0.269l-0 0c0.075-0.075 0.164-0.137 0.263-0.18l0.006-0.002c0.096-0.042 0.208-0.067 0.326-0.067 0 0 0 0 0 0v0c0.121 0 0.237 0.025 0.342 0.069l-0.006-0.002c0.107 0.044 0.197 0.106 0.274 0.182l0 0c0.077 0.075 0.138 0.164 0.18 0.264l0.002 0.005c0.045 0.097 0.072 0.211 0.072 0.331 0 0.002 0 0.003-0 0.005v-0zM12.655 10.464v5.539h-1.334v-5.539z" />
  </SvgIcon>
);
export const MinusIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M15.861 12.24h-7.723c-0.133 0-0.24-0.107-0.24-0.24v0c0-0.133 0.107-0.24 0.24-0.24v0h7.723c0.133 0 0.24 0.107 0.24 0.24v0c-0.003 0.131-0.109 0.237-0.24 0.24h-0z" />
  </SvgIcon>
);
export const PlusIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M15.562 11.918h-3.624v-3.624c0-0.133-0.107-0.24-0.24-0.24v0c-0.131 0.003-0.237 0.109-0.24 0.24v3.624h-3.619c-0.133 0-0.24 0.107-0.24 0.24v0c0 0.133 0.107 0.24 0.24 0.24v0h3.619v3.619c0 0.133 0.107 0.24 0.24 0.24v0c0.133 0 0.24-0.107 0.24-0.24v0-3.619h3.624c0.131-0.003 0.237-0.109 0.24-0.24v-0c0-0.133-0.107-0.24-0.24-0.24v0z" />
  </SvgIcon>
);

export const ResetIcon = (props) => (
  <SvgIcon x="0px" y="0px" viewBox="0 0 63.408 63.408" {...props}>
    <g id="Gruppe_517_3_" transform="translate(0.594 0.51)">
      <g>
        <defs>
          <rect
            id="SVGID_13_"
            x="12.526"
            y="12.294"
            width="38.233"
            height="38.233"
          />
        </defs>
        <clipPath id="SVGID_2_">
          <use xlinkHref="#SVGID_13_" style={{ overflow: "visible" }} />
        </clipPath>
        <g
          id="Gruppe_516_3_"
          transform="translate(-0.705 -0.621)"
          style={{ clipPath: "url(#SVGID_2_)" }}
        >
          <g id="Ellipse_90_2_">
            <path
              d="M32.385,50.307C22.247,50.307,14,42.059,14,31.922s8.247-18.385,18.385-18.385c10.137,0,18.384,8.248,18.384,18.385
					S42.521,50.307,32.385,50.307z M32.385,15.537C23.351,15.537,16,22.888,16,31.922c0,9.034,7.351,16.384,16.385,16.384
					s16.384-7.35,16.384-16.384C48.769,22.888,41.419,15.537,32.385,15.537z"
            />
          </g>
          <g id="Pfad_258_3_">
            <path
              d="M39.497,40.818c-0.553,0-1-0.448-1-1c0-0.491,0.354-0.899,0.819-0.984c0.598-0.507,1.844-3.624,1.206-5.771
					c-0.349-1.174-1.177-1.721-2.605-1.721H22.902c-0.553,0-1-0.448-1-1s0.447-1,1-1h15.015c2.055,0,3.175,0.883,3.753,1.623
					c0.683,0.874,1.029,2.035,1.029,3.45C42.699,36.994,41.355,40.818,39.497,40.818z"
            />
          </g>
          <g id="Pfad_259_3_">
            <path
              d="M27.644,36.076c-0.256,0-0.512-0.098-0.707-0.292l-4.741-4.734c-0.188-0.188-0.293-0.442-0.293-0.707
					c0-0.266,0.105-0.52,0.293-0.708l4.741-4.741c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-4.033,4.033l4.033,4.027
					c0.391,0.39,0.391,1.023,0.001,1.414C28.156,35.978,27.899,36.076,27.644,36.076z"
            />
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const ChevronDownIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M12.396 15.677c-0.001 0-0.001 0-0.002 0-0.062 0-0.119-0.024-0.162-0.063l0 0-7.598-6.912 0.326-0.379 7.426 6.778 6.634-6.768 0.346 0.336-6.802 6.936c-0.041 0.044-0.1 0.072-0.165 0.072-0.001 0-0.002 0-0.003-0h0z" />
  </SvgIcon>
);

export const ChevronLeftIcon = (props) => (
  <SvgIcon {...props}>
    <path
      stroke="white"
      stroke-width="2"
      d="M8.323 12.396c0-0.001 0-0.001 0-0.002 0-0.062 0.024-0.119 0.063-0.162l-0 0 6.912-7.598 0.379 0.326-6.778 7.426 6.768 6.634-0.336 0.346-6.936-6.802c-0.044-0.041-0.072-0.1-0.072-0.165 0-0.001 0-0.002 0-0.003v0z"
    />
  </SvgIcon>
);
export const ChevronUpIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M12.396 8.323c-0.001 0-0.001 0-0.002 0-0.062 0-0.119 0.024-0.162 0.063l0-0-7.598 6.912 0.326 0.379 7.426-6.778 6.634 6.768 0.346-0.336-6.802-6.936c-0.041-0.044-0.1-0.072-0.165-0.072-0.001 0-0.002 0-0.003 0h0z" />
  </SvgIcon>
);
export const ChevronRightIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M15.677 11.604c0 0.001 0 0.001 0 0.002 0 0.062-0.024 0.119-0.063 0.162l0-0-6.912 7.598-0.379-0.326 6.778-7.426-6.768-6.634 0.336-0.346 6.936 6.802c0.044 0.041 0.072 0.1 0.072 0.165 0 0.001 0 0.002-0 0.003v-0z" />
  </SvgIcon>
);
export const CatalogueIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M19.865 4.463c-0.033-0.019-0.073-0.031-0.115-0.031s-0.082 0.011-0.116 0.031l0.001-0.001-7.627 3.802-7.627-3.811c-0.032-0.017-0.070-0.028-0.111-0.028-0.13 0-0.235 0.105-0.235 0.235 0 0.003 0 0.006 0 0.009l-0-0v12c0 0.001-0 0.002-0 0.003 0 0.092 0.052 0.172 0.128 0.212l0.001 0.001 7.733 3.84c0.029 0.015 0.064 0.024 0.1 0.024 0 0 0 0 0.001 0h-0c0.037-0.001 0.071-0.010 0.102-0.025l-0.002 0.001 7.733-3.84c0.080-0.041 0.133-0.122 0.134-0.216v-12c0-0.003 0-0.007 0-0.011 0-0.080-0.040-0.152-0.1-0.195l-0.001-0zM4.505 5.058l7.262 3.605v11.472l-7.253-3.629zM19.5 16.506l-7.253 3.629v-11.472l7.253-3.605z" />
    <path d="M5.71 3.705l6.206 3.13c0.029 0.015 0.064 0.024 0.101 0.024 0.003 0 0.007-0 0.010-0l-0 0c0.002 0 0.005 0 0.008 0 0.036 0 0.070-0.009 0.099-0.025l-0.001 0.001 6.168-3.13c0.070-0.043 0.116-0.119 0.116-0.206 0-0.133-0.107-0.24-0.24-0.24-0.033 0-0.065 0.007-0.094 0.019l0.002-0.001-6.077 3.072-6.082-3.072c-0.032-0.017-0.070-0.027-0.11-0.027-0.093 0-0.173 0.054-0.211 0.131l-0.001 0.001c-0.015 0.031-0.024 0.067-0.024 0.106 0 0.093 0.052 0.174 0.128 0.215l0.001 0.001z" />
  </SvgIcon>
);
export const ConfigurateColorsBlackIcon = (props) => (
  <SvgIcon {...props}>
    <path
      fill="#000"
      d="M14.565 5.855l-0.341-0.677 0.106-0.168c0.023-0.036 0.037-0.080 0.037-0.127 0-0.086-0.045-0.161-0.112-0.203l-0.001-0.001 0.216-0.355c0.036-0.062 0.058-0.137 0.058-0.216 0-0.159-0.086-0.298-0.214-0.373l-0.002-0.001-0.394-0.24c-0.061-0.035-0.134-0.056-0.212-0.056-0.16 0-0.299 0.088-0.372 0.217l-0.001 0.002-0.226 0.336c-0.036-0.022-0.080-0.035-0.127-0.035-0.019 0-0.039 0.002-0.057 0.006l0.002-0c-0.063 0.015-0.115 0.053-0.148 0.105l-0.001 0.001-2.4 3.907-3.36 5.434c-0.010 0.018-0.018 0.039-0.024 0.061l-0 0.002-0.6 2.27c-0.006 0.019-0.009 0.042-0.009 0.065 0 0.085 0.046 0.159 0.114 0.199l0.001 0.001c0.035 0.023 0.078 0.037 0.125 0.038h0c0.061-0.001 0.116-0.025 0.159-0.063l-0 0 1.757-1.56c0.018-0.015 0.034-0.033 0.047-0.052l0.001-0.001 5.357-8.712 0.144 0.288-1.282 2.088c-0.024 0.036-0.038 0.080-0.038 0.127 0 0.085 0.046 0.159 0.114 0.199l0.001 0.001c0.035 0.023 0.078 0.037 0.125 0.038h0c0.086-0.001 0.162-0.047 0.206-0.114l0.001-0.001 1.354-2.198c0.018-0.033 0.029-0.073 0.029-0.115s-0.011-0.082-0.029-0.116l0.001 0.001z"
    />
    <path
      fill="#ff1919"
      d="M11.993 13.382c-0.854 0-1.546 0.692-1.546 1.546s0.692 1.546 1.546 1.546c0.854 0 1.546-0.692 1.546-1.546v0c0-0.854-0.692-1.546-1.546-1.546v0z"
    />
    <path
      fill="#000"
      d="M11.993 16.636c-0.946 0-1.714-0.767-1.714-1.714s0.767-1.714 1.714-1.714c0.946 0 1.714 0.767 1.714 1.714 0 0.002 0 0.003 0 0.005v-0c-0.003 0.944-0.769 1.709-1.714 1.709 0 0 0 0 0 0v0zM11.993 13.55c-0.001 0-0.003 0-0.005 0-0.761 0-1.378 0.617-1.378 1.378s0.617 1.378 1.378 1.378c0.761 0 1.378-0.617 1.378-1.378v0c0 0 0 0 0 0 0-0.759-0.614-1.375-1.373-1.378h-0z"
    />
    <path
      fill="#00ffd8"
      d="M17.445 14.927c0 0.851-0.69 1.541-1.541 1.541s-1.541-0.69-1.541-1.541c0-0.851 0.69-1.541 1.541-1.541s1.541 0.69 1.541 1.541z"
    />
    <path
      fill="#000"
      d="M15.905 16.636c-0.946 0-1.714-0.767-1.714-1.714s0.767-1.714 1.714-1.714c0.946 0 1.714 0.767 1.714 1.714 0 0.002 0 0.003 0 0.005v-0c-0.003 0.944-0.769 1.709-1.714 1.709 0 0 0 0 0 0v0zM15.905 13.55c-0.753 0.011-1.358 0.623-1.358 1.377 0 0.761 0.617 1.378 1.378 1.378s1.378-0.617 1.378-1.377v0c0-0 0-0 0-0 0-0.761-0.617-1.378-1.378-1.378-0.007 0-0.014 0-0.020 0h0.001z"
    />
    <path
      fill="#3900f8"
      d="M13.533 18.849c0 0.851-0.69 1.541-1.541 1.541s-1.541-0.69-1.541-1.541c0-0.851 0.69-1.541 1.541-1.541s1.541 0.69 1.541 1.541z"
    />
    <path
      fill="#000"
      d="M11.993 20.563c-0.946-0-1.713-0.767-1.713-1.714s0.767-1.714 1.714-1.714 1.714 0.767 1.714 1.714c0 0.008-0 0.017-0 0.025l0-0.001c-0.014 0.936-0.775 1.69-1.713 1.69-0 0-0 0-0 0v0zM11.993 17.476c-0.758 0-1.373 0.615-1.373 1.373s0.615 1.373 1.373 1.373c0.75 0 1.359-0.601 1.373-1.348l0-0.001c0-0.006 0-0.012 0-0.019 0-0.759-0.614-1.375-1.373-1.378h-0z"
    />
    <path
      fill="#ffeb00"
      d="M17.445 18.849c0 0.851-0.69 1.541-1.541 1.541s-1.541-0.69-1.541-1.541c0-0.851 0.69-1.541 1.541-1.541s1.541 0.69 1.541 1.541z"
    />
    <path
      fill="#000"
      d="M15.905 20.563c-0.946-0-1.713-0.767-1.713-1.714s0.767-1.714 1.714-1.714 1.714 0.767 1.714 1.714c0 0.008-0 0.017-0 0.025l0-0.001c-0.014 0.936-0.775 1.69-1.713 1.69-0 0-0 0-0 0v0zM15.905 17.476c-0.748 0.014-1.349 0.623-1.349 1.373 0 0.758 0.615 1.373 1.373 1.373 0.75 0 1.359-0.601 1.373-1.347l0-0.001c0-0.006 0-0.013 0-0.019 0-0.761-0.617-1.378-1.378-1.378-0.007 0-0.014 0-0.020 0h0.001z"
    />
  </SvgIcon>
);

export const ConfigurateColorsWhiteIcon = (props) => (
  <SvgIcon {...props}>
    <path
      fill="#fff"
      d="M14.564 5.86l-0.338-0.672 0.105-0.171c0.070-0.112 0.034-0.26-0.078-0.329l-0.020-0.012 0.217-0.354c0.119-0.204 0.046-0.47-0.16-0.59l-0.393-0.243c-0.205-0.118-0.463-0.043-0.586 0.165l-0.203 0.328-0.013-0.008c-0.054-0.034-0.121-0.044-0.181-0.029-0.062 0.015-0.115 0.054-0.149 0.108l-2.387 3.909-3.36 5.43c-0.012 0.020-0.022 0.042-0.028 0.065l-0.599 2.27c-0.027 0.102 0.016 0.21 0.106 0.265 0.039 0.024 0.083 0.036 0.126 0.036 0.057 0 0.114-0.020 0.159-0.060l1.757-1.558c0.017-0.015 0.033-0.034 0.045-0.054l5.348-8.688 0.145 0.289-1.284 2.084c-0.070 0.113-0.034 0.26 0.078 0.329 0.039 0.024 0.083 0.036 0.126 0.036 0.080 0 0.158-0.040 0.204-0.114l1.354-2.197c0.045-0.071 0.048-0.159 0.011-0.233z"
    />
    <path
      fill="#ff1919"
      d="M13.536 14.932c0 0.851-0.69 1.542-1.542 1.542s-1.542-0.69-1.542-1.542c0-0.851 0.69-1.542 1.542-1.542s1.542 0.69 1.542 1.542z"
    />
    <path
      fill="#fff"
      d="M11.994 16.643c-0.943 0-1.711-0.768-1.711-1.71s0.768-1.71 1.711-1.71 1.71 0.768 1.71 1.71-0.767 1.71-1.71 1.71zM11.994 13.559c-0.757 0-1.373 0.616-1.373 1.373s0.616 1.373 1.373 1.373c0.757 0 1.373-0.616 1.373-1.373s-0.616-1.373-1.373-1.373z"
    />
    <path
      fill="#00ffd8"
      d="M17.449 14.932c0 0.851-0.69 1.542-1.542 1.542s-1.542-0.69-1.542-1.542c0-0.851 0.69-1.542 1.542-1.542s1.542 0.69 1.542 1.542z"
    />
    <path
      fill="#fff"
      d="M15.907 16.643c-0.943 0-1.71-0.768-1.71-1.71s0.768-1.71 1.71-1.71 1.71 0.768 1.71 1.71-0.767 1.71-1.71 1.71zM15.907 13.559c-0.757 0-1.373 0.616-1.373 1.373s0.616 1.373 1.373 1.373 1.373-0.616 1.373-1.373-0.616-1.373-1.373-1.373z"
    />
    <path
      fill="#3900f8"
      d="M13.536 18.857c0 0.851-0.69 1.542-1.542 1.542s-1.542-0.69-1.542-1.542c0-0.851 0.69-1.542 1.542-1.542s1.542 0.69 1.542 1.542z"
    />
    <path
      fill="#fff"
      d="M11.994 20.567c-0.943 0-1.711-0.768-1.711-1.71s0.768-1.71 1.711-1.71 1.71 0.768 1.71 1.71-0.767 1.71-1.71 1.71zM11.994 17.483c-0.757 0-1.373 0.616-1.373 1.373s0.616 1.373 1.373 1.373c0.757 0 1.373-0.616 1.373-1.373s-0.616-1.373-1.373-1.373z"
    />
    <path
      fill="#ffeb00"
      d="M17.449 18.857c0 0.851-0.69 1.542-1.542 1.542s-1.542-0.69-1.542-1.542c0-0.851 0.69-1.542 1.542-1.542s1.542 0.69 1.542 1.542z"
    />
    <path
      fill="#fff"
      d="M15.907 20.567c-0.943 0-1.71-0.768-1.71-1.71s0.768-1.71 1.71-1.71 1.71 0.768 1.71 1.71-0.767 1.71-1.71 1.71zM15.907 17.483c-0.757 0-1.373 0.616-1.373 1.373s0.616 1.373 1.373 1.373 1.373-0.616 1.373-1.373-0.616-1.373-1.373-1.373z"
    />
  </SvgIcon>
);

export const ConfigurateImprintIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M18.623 15.349v-2.261h-2.261v0.869h-3.979v-0.869h-2.261v2.261h0.883v3.086h-0.883v2.242h2.261v-0.874h3.979v0.874h2.261v-2.242h-0.898v-3.086zM16.842 13.568h1.301v1.301h-1.301zM10.602 13.568h1.301v1.301h-1.301zM11.903 20.197h-1.301v-1.282h1.301zM18.143 20.197h-1.301v-1.282h1.301zM17.245 18.435h-0.883v0.888h-3.979v-0.888h-0.898v-3.086h0.888v-0.912h3.979v0.912h0.893z" />
    <path d="M13.559 5.739l-0.336-0.677 0.106-0.168c0.022-0.036 0.035-0.079 0.035-0.125 0-0.087-0.046-0.163-0.116-0.205l-0.001-0.001 0.221-0.355c0.035-0.061 0.055-0.134 0.055-0.212 0-0.161-0.087-0.301-0.216-0.377l-0.002-0.001-0.394-0.24c-0.061-0.034-0.133-0.055-0.21-0.055-0.16 0-0.299 0.087-0.374 0.216l-0.001 0.002-0.221 0.336c-0.036-0.022-0.079-0.035-0.126-0.035-0.086 0-0.161 0.044-0.205 0.111l-0.001 0.001-2.4 3.907-3.36 5.434c-0.014 0.017-0.024 0.038-0.029 0.061l-0 0.001-0.6 2.27c-0.004 0.017-0.007 0.037-0.007 0.058 0 0.087 0.047 0.164 0.116 0.206l0.001 0.001c0.035 0.023 0.078 0.037 0.125 0.038h0c0.061-0.002 0.116-0.025 0.159-0.063l-0 0 1.757-1.56c0.018-0.014 0.033-0.032 0.043-0.052l0-0.001 5.347-8.712 0.149 0.288-1.286 2.088c-0.022 0.035-0.034 0.078-0.034 0.124 0 0.085 0.044 0.159 0.11 0.202l0.001 0.001c0.037 0.023 0.082 0.037 0.129 0.038l0 0c0.085-0.001 0.159-0.047 0.201-0.114l0.001-0.001 1.354-2.198c0.023-0.035 0.036-0.078 0.036-0.124 0-0.039-0.010-0.076-0.027-0.108l0.001 0.001z" />
  </SvgIcon>
);

export const DownloadIcon = (props) => (
  <SvgIcon {...props} viewBox="-4.5 -3.5 24 24">
    <g
      id="Gruppe_522"
      data-name="Gruppe 522"
      transform="translate(-241 -5112.999)"
    >
      <path
        id="Pfad_101"
        data-name="Pfad 101"
        d="M249.448,5130.188H241.5V5113.5h8.742l3.974,3.974v3.178"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <path
        id="Pfad_102"
        data-name="Pfad 102"
        d="M252.5,5113.5v3.974h3.974"
        transform="translate(-2.258)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <circle
        id="Ellipse_51"
        data-name="Ellipse 51"
        cx="4.5"
        cy="4.5"
        r="4.5"
        transform="translate(250.5 5122.499)"
        fill="none"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="1"
      />
      <line
        id="Linie_39"
        data-name="Linie 39"
        y1="4.335"
        transform="translate(255.011 5124.84)"
        fill="none"
        stroke="#000"
        strokeMiterlimit="round"
        strokeMiterlimit="10"
        strokeWidth="1"
      />
      <path
        id="Pfad_103"
        data-name="Pfad 103"
        d="M256.318,5131.044l1.734,1.734,1.734-1.734"
        transform="translate(-3.041 -3.601)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1"
      />
    </g>
  </SvgIcon>
);

export const EditPenIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M16.85 7.372l-0.418-0.83 0.139-0.226c0.022-0.036 0.035-0.079 0.035-0.126 0-0.086-0.044-0.161-0.111-0.205l-0.001-0.001-0.067-0.038 0.288-0.48c0.037-0.066 0.059-0.146 0.059-0.23 0-0.043-0.006-0.084-0.016-0.124l0.001 0.003c-0.031-0.116-0.101-0.213-0.195-0.277l-0.002-0.001-0.48-0.293c-0.065-0.035-0.142-0.055-0.224-0.055-0.176 0-0.33 0.095-0.413 0.236l-0.001 0.002-0.269 0.432-0.058-0.034c-0.036-0.022-0.079-0.036-0.126-0.036-0.020 0-0.040 0.002-0.058 0.007l0.002-0c-0.064 0.015-0.117 0.055-0.148 0.109l-0.001 0.001-2.88 4.685-4.032 6.518c-0.014 0.019-0.024 0.042-0.029 0.066l-0 0.001-0.715 2.722c-0.006 0.020-0.010 0.043-0.010 0.066 0 0.091 0.052 0.169 0.128 0.207l0.001 0.001c0.035 0.023 0.078 0.037 0.125 0.038h0c0.061-0.001 0.116-0.025 0.159-0.063l-0 0 2.117-1.896c0.018-0.015 0.034-0.033 0.047-0.052l0.001-0.001 6.432-10.478 0.24 0.451-1.555 2.525c-0.022 0.036-0.035 0.079-0.035 0.126 0 0.086 0.044 0.161 0.111 0.205l0.001 0.001c0.037 0.021 0.081 0.034 0.128 0.034 0.001 0 0.001 0 0.002 0h-0c0.001 0 0.001 0 0.002 0 0.085 0 0.159-0.046 0.199-0.114l0.001-0.001 1.627-2.64c0.018-0.034 0.029-0.075 0.029-0.118s-0.011-0.083-0.029-0.119l0.001 0.001z" />
  </SvgIcon>
);

export const FullscreenIcon = (props) => (
  <SvgIcon
    style={{ enableBackground: "new 0 0 50 50" }}
    viewBox="0 0 50 50"
    {...props}
  >
    <g>
      <path
        d="M43.083,6.278H29.222c-0.828,0-1.5,0.671-1.5,1.5s0.672,1.5,1.5,1.5H39.81l-9.754,9.754c-0.586,0.585-0.586,1.535,0,2.121
		c0.293,0.293,0.677,0.439,1.061,0.439s0.768-0.146,1.061-0.439l9.406-9.406v9.891c0,0.829,0.672,1.5,1.5,1.5s1.5-0.671,1.5-1.5
		V7.778C44.583,6.95,43.911,6.278,43.083,6.278z"
      />
      <path
        d="M21.52,41.7h-9.89l9.293-9.294c0.586-0.586,0.586-1.536,0-2.121c-0.586-0.586-1.535-0.586-2.121,0L9.16,39.928V29.34
		c0-0.829-0.672-1.5-1.5-1.5s-1.5,0.671-1.5,1.5V43.2c0,0.829,0.672,1.5,1.5,1.5h0.346c0.001,0,0.001,0,0.002,0s0.002,0,0.002,0
		H21.52c0.828,0,1.5-0.671,1.5-1.5S22.349,41.7,21.52,41.7z"
      />
    </g>
  </SvgIcon>
);

export const PenIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M13.374 5.321l-0.787-0.48v-0.274c0-0.133-0.107-0.24-0.24-0.24v0h-0.077v-0.547c-0.006-0.126-0.060-0.239-0.144-0.322l-0-0c-0.090-0.082-0.209-0.132-0.34-0.134h-0.533c-0.25 0.018-0.446 0.226-0.446 0.479 0 0 0 0.001 0 0.001v-0 0.523h-0.062c-0.003-0-0.006-0-0.010-0-0.127 0-0.23 0.103-0.23 0.23 0 0.003 0 0.007 0 0.010l-0-0v13.171c-0.001 0.011-0.002 0.023-0.002 0.036s0.001 0.025 0.002 0.038l-0-0.002 0.816 2.693c0.030 0.101 0.122 0.173 0.23 0.173v0c0.108-0.002 0.199-0.073 0.23-0.171l0-0.002 0.816-2.698c0.001-0.010 0.002-0.022 0.002-0.034s-0.001-0.024-0.002-0.035l0 0.001v-12.341l0.422 0.259v2.962c0 0.133 0.107 0.24 0.24 0.24v0c0.133 0 0.24-0.107 0.24-0.24v0-3.096c-0.002-0.087-0.052-0.162-0.124-0.201l-0.001-0.001zM11.53 19.586l-0.576-1.92v-7.027h1.138v7.042z" />
  </SvgIcon>
);

export const LoadIcon = (props) => (
  <SvgIcon {...props} viewBox="-2 -4 24 24">
    <g
      id="Gruppe_520"
      data-name="Gruppe 520"
      transform="translate(-289 -4635.5)"
    >
      <path
        id="Pfad_92"
        data-name="Pfad 92"
        d="M304.994,4649.7"
        transform="translate(-1.805 -1.595)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1"
      />
      <path
        id="Pfad_93"
        data-name="Pfad 93"
        d="M303.016,4647.833h2.119s3.8-.5,3.8-4.226a4.218,4.218,0,0,0-4.378-4.218,5.906,5.906,0,0,0-11.238,2.172,3.169,3.169,0,0,0-3.821,3.1c0,3.22,3.38,3.169,3.38,3.169h2.53"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1"
      />
      <line
        id="Linie_37"
        data-name="Linie 37"
        y2="9.719"
        transform="translate(299.219 4642.799)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <path
        id="Pfad_94"
        data-name="Pfad 94"
        d="M302.8,4646.347l-2.651-2.65-2.651,2.65"
        transform="translate(-0.932 -0.897)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
    </g>
  </SvgIcon>
);

export const LoadDarkIcon = (props) => (
  <SvgIcon {...props} viewBox="-2 -4 24 24">
    <g
      id="Gruppe_520"
      data-name="Gruppe 520"
      transform="translate(-289 -4635.5)"
    >
      <path
        id="Pfad_92"
        data-name="Pfad 92"
        d="M304.994,4649.7"
        transform="translate(-1.805 -1.595)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1"
      />
      <path
        id="Pfad_93"
        data-name="Pfad 93"
        d="M303.016,4647.833h2.119s3.8-.5,3.8-4.226a4.218,4.218,0,0,0-4.378-4.218,5.906,5.906,0,0,0-11.238,2.172,3.169,3.169,0,0,0-3.821,3.1c0,3.22,3.38,3.169,3.38,3.169h2.53"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1"
      />
      <line
        id="Linie_37"
        data-name="Linie 37"
        y2="9.719"
        transform="translate(299.219 4642.799)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <path
        id="Pfad_94"
        data-name="Pfad 94"
        d="M302.8,4646.347l-2.651-2.65-2.651,2.65"
        transform="translate(-0.932 -0.897)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
    </g>
  </SvgIcon>
);
export const LoginIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M11.985 10.572c-1.964 0-3.557-1.592-3.557-3.557s1.592-3.557 3.557-3.557c1.964 0 3.557 1.592 3.557 3.557v0c-0.003 1.963-1.594 3.554-3.557 3.557h-0zM11.985 3.939c-1.699 0-3.077 1.378-3.077 3.077s1.378 3.077 3.077 3.077c1.699 0 3.077-1.378 3.077-3.077v0c-0.014-1.69-1.385-3.055-3.077-3.058h-0z" />
    <path d="M18.888 20.542h-13.79v-0.24c0-6.485 4.517-8.198 6.902-8.198 1.701 0.032 3.244 0.684 4.418 1.738l-0.006-0.006c1.627 1.464 2.491 3.701 2.491 6.466zM5.577 20.062h12.826c-0.048-2.515-0.85-4.541-2.328-5.87-1.082-0.973-2.512-1.578-4.083-1.608l-0.006-0c-2.194 0-6.312 1.57-6.408 7.478z" />
  </SvgIcon>
);

export const MailIcon = (props) => (
  <SvgIcon {...props} viewBox="-3 -6 24 24">
    <g id="Gruppe_521" data-name="Gruppe 521" transform="translate(-433 -2668)">
      <rect
        id="Rechteck_37"
        data-name="Rechteck 37"
        width="18"
        height="12"
        rx="1.5"
        transform="translate(433.5 2668.5)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <path
        id="Pfad_88"
        data-name="Pfad 88"
        d="M452.143,2669l-8.571,6.857L435,2669"
        transform="translate(-1.071 -0.071)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
    </g>
  </SvgIcon>
);

export const PricelistIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M15.408 7.206c-0.002-0.070-0.031-0.132-0.077-0.178v0l-3.682-3.667c-0.023-0.024-0.050-0.043-0.080-0.057l-0.002-0.001c-0.011-0.001-0.023-0.002-0.036-0.002s-0.025 0.001-0.038 0.002l0.002-0h-8.088c-0.131 0.003-0.237 0.109-0.24 0.24v15.432c0.003 0.131 0.109 0.237 0.24 0.24h7.335v-0.48h-7.118v-14.971h7.613v3.442c0.003 0.131 0.109 0.237 0.24 0.24h3.451v2.702h0.48v-2.938zM11.717 4.105l2.88 2.88h-2.88z" />
    <path d="M16.171 20.699c-2.574 0-4.661-2.087-4.661-4.661s2.087-4.661 4.661-4.661c2.574 0 4.661 2.087 4.661 4.661v0c-0.003 2.573-2.088 4.658-4.661 4.661h-0zM16.171 11.857c-2.309 0-4.181 1.872-4.181 4.181s1.872 4.181 4.181 4.181c2.309 0 4.181-1.872 4.181-4.181v0c0-2.31-1.871-4.183-4.181-4.186h-0z" />
    <path d="M17.131 17.91c-1.224 0-1.891-0.317-2.141-1.056h1.181c0.131-0.003 0.237-0.109 0.24-0.24v-0c0-0.133-0.107-0.24-0.24-0.24v0h-1.277c0-0.11-0.024-0.216-0.024-0.336s0-0.163 0-0.24h1.666c0.131-0.003 0.237-0.109 0.24-0.24v-0c0-0.133-0.107-0.24-0.24-0.24v0h-1.57c0.226-0.806 0.893-1.157 2.165-1.157 0.133 0 0.24-0.107 0.24-0.24v0c-0.003-0.131-0.109-0.237-0.24-0.24h-0c-1.027 0-2.347 0.187-2.664 1.637h-0.413c-0.133 0-0.24 0.107-0.24 0.24v0c0.003 0.131 0.109 0.237 0.24 0.24h0.351c0 0.077 0 0.154 0 0.24s0 0.226 0 0.336h-0.355c-0.133 0-0.24 0.107-0.24 0.24v0c0.003 0.131 0.109 0.237 0.24 0.24h0.437c0.36 1.354 1.637 1.536 2.64 1.536 0.133 0 0.24-0.107 0.24-0.24s-0.107-0.24-0.24-0.24v0z" />
  </SvgIcon>
);

export const ProductfinderIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M3.816 10.99h0.518v0.067c0.002 0.066 0.029 0.125 0.072 0.168v0c0.044 0.042 0.102 0.069 0.168 0.072l0 0h13.171c0.010 0.002 0.022 0.004 0.034 0.004s0.024-0.001 0.035-0.004l-0.001 0 2.698-0.816c0.098-0.032 0.168-0.122 0.168-0.229 0-0.001 0-0.001 0-0.002v0c0-0.001 0-0.002 0-0.004 0-0.105-0.070-0.194-0.166-0.221l-0.002-0-2.698-0.816c-0.010-0.002-0.022-0.003-0.034-0.003s-0.024 0.001-0.035 0.004l0.001-0h-12.336l0.259-0.427h2.962c0.133 0 0.24-0.107 0.24-0.24v0c0-0.133-0.107-0.24-0.24-0.24v0h-3.096c-0.085 0-0.16 0.046-0.201 0.114l-0.001 0.001-0.48 0.792h-0.278c-0.133 0-0.24 0.107-0.24 0.24v0 0.072h-0.557c-0.255 0.013-0.456 0.223-0.456 0.479 0 0 0 0 0 0.001v-0 0.542c0.018 0.25 0.225 0.447 0.479 0.447 0.005 0 0.011-0 0.016-0l-0.001 0zM19.617 10.241l-1.92 0.571h-7.027v-1.147h7.027z" />
    <path d="M20.174 13.015h-0.509v-0.072c-0.003-0.131-0.109-0.237-0.24-0.24h-13.224l-2.693 0.816c-0.1 0.031-0.171 0.122-0.173 0.23v0c0 0.109 0.072 0.2 0.171 0.23l0.002 0 2.693 0.816h12.394l-0.264 0.422h-2.962c-0.133 0-0.24 0.107-0.24 0.24s0.107 0.24 0.24 0.24h3.096c0.001 0 0.001 0 0.002 0 0.085 0 0.16-0.043 0.204-0.11l0.001-0.001 0.48-0.792h0.264c0.133 0 0.24-0.107 0.24-0.24v0-0.077h0.542c0.001 0 0.001 0 0.002 0 0.127 0 0.241-0.056 0.319-0.144l0-0c0.083-0.086 0.134-0.204 0.134-0.333 0-0.003-0-0.005-0-0.008v0-0.533c-0.018-0.25-0.226-0.446-0.479-0.446-0 0-0.001 0-0.001 0h0zM4.406 13.764l1.92-0.576h7.022v1.133h-7.042z" />
  </SvgIcon>
);

export const SaveIcon = (props) => (
  <SvgIcon {...props} viewBox="-4.5 -3.5 24 24">
    <path
      id="Pfad_104"
      data-name="Pfad 104"
      d="M153.326,5129.934H145.5V5113.5h8.609l3.913,3.914v3.13"
      transform="translate(-145.5 -5113.499)"
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth="1"
    />
    <path
      id="Pfad_105"
      data-name="Pfad 105"
      d="M156.5,5113.5v3.913h3.913"
      transform="translate(-147.891 -5113.499)"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    />
    <circle
      id="Ellipse_52"
      data-name="Ellipse 52"
      cx="4.5"
      cy="4.5"
      r="4.5"
      transform="translate(9 9)"
      fill="none"
      stroke="#000"
      strokeMiterlimit="10"
      strokeWidth="1"
    />
    <path
      id="Pfad_106"
      data-name="Pfad 106"
      d="M164.35,5128.862l-2.988,3.275L159.227,5130"
      transform="translate(-148.484 -5116.838)"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="1"
    />
  </SvgIcon>
);

export const SearchIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M10.528 17.34c-3.764 0-6.816-3.052-6.816-6.816s3.052-6.816 6.816-6.816c3.764 0 6.816 3.052 6.816 6.816v0c-0.005 3.762-3.054 6.811-6.815 6.816h-0.001zM10.528 4.188c-3.499 0-6.336 2.837-6.336 6.336s2.837 6.336 6.336 6.336c3.499 0 6.336-2.837 6.336-6.336v0c-0.003-3.498-2.838-6.333-6.336-6.336h-0z" />
    <path d="M20.051 20.287c-0.068-0-0.129-0.028-0.173-0.072v0l-4.872-4.872c-0.044-0.044-0.071-0.104-0.071-0.17 0-0.133 0.108-0.241 0.241-0.241 0.067 0 0.127 0.027 0.17 0.071v0l4.872 4.882c0.042 0.043 0.069 0.103 0.069 0.168 0 0.131-0.106 0.238-0.236 0.24h-0z" />
  </SvgIcon>
);

export const TicBigIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M10.079 16.789l-4.531-4.19c-0.040-0.043-0.065-0.101-0.065-0.164 0-0.133 0.107-0.24 0.24-0.24 0.057 0 0.11 0.020 0.152 0.054l-0-0 4.176 3.84 8.040-8.789c0.044-0.055 0.112-0.090 0.187-0.090 0.133 0 0.24 0.107 0.24 0.24 0 0.067-0.028 0.128-0.072 0.171l-0 0z" />
  </SvgIcon>
);

export const TicSmallIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M11.161 14.296l-2.117-1.954c-0.048-0.044-0.078-0.107-0.078-0.178 0-0.133 0.108-0.241 0.241-0.241 0.063 0 0.12 0.024 0.163 0.064l-0-0 1.762 1.627 3.49-3.84c0.043-0.044 0.104-0.071 0.17-0.071s0.127 0.027 0.17 0.071l0 0c0.044 0.043 0.071 0.102 0.071 0.168s-0.027 0.125-0.071 0.168l-0 0z" />
  </SvgIcon>
);

export const TopPenIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M14.486 11.782l-2.827-0.864h-2.074c-0.133 0-0.24 0.107-0.24 0.24v0 1.68c0.001 0.067 0.028 0.128 0.072 0.173l-0-0c0.043 0.043 0.102 0.070 0.168 0.072h2.069l2.827-0.845c0.1-0.031 0.171-0.122 0.173-0.23v-0c-0.002-0.105-0.071-0.194-0.166-0.225l-0.002-0z" />
  </SvgIcon>
);

export const ConfigurateDesignerImageIcon = (props) => (
  <SvgIcon {...props}>
    <g
      id="Gruppe_605"
      data-name="Gruppe 605"
      transform="translate(-216.5 -351)"
    >
      <g
        id="Gruppe_69"
        data-name="Gruppe 69"
        transform="translate(223.264 355.332)"
      >
        <path
          id="Pfad_131"
          data-name="Pfad 131"
          d="M334,4854.484h11.456l-3.645-8.852-3.124,5.728-2.083-2.083Z"
          transform="translate(-334 -4841.987)"
          fill="none"
          stroke="#231f20"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <ellipse
          id="Ellipse_60"
          data-name="Ellipse 60"
          cx="1.562"
          cy="1.562"
          rx="1.562"
          ry="1.562"
          transform="translate(0)"
          fill="none"
          stroke="#231f20"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
      </g>
      <rect
        id="Rechteck_78"
        data-name="Rechteck 78"
        width="22"
        height="22"
        rx="0.567"
        transform="translate(217 351.5)"
        fill="none"
        stroke="#231f20"
        strokeMiterlimit="10"
        strokeWidth="1"
      />
    </g>
  </SvgIcon>
);
export const ConfigurateDesignerTextIcon = (props) => (
  <SvgIcon {...props}>
    <g id="Gruppe_467" data-name="Gruppe 467" transform="translate(0)">
      <text
        id="A"
        transform="translate(-6)"
        fontSize="18"
        fontFamily="Lato-Bold, Lato"
        fontWeight="700"
        letterSpacing="0.01em"
      >
        <tspan x="7.25" y="18">
          A
        </tspan>
      </text>
      <line
        id="Linie_52"
        data-name="Linie 52"
        x2="14"
        transform="translate(0 21.338)"
        fill="none"
        stroke="#000"
        strokeWidth="1"
      />
    </g>
  </SvgIcon>
);
